import axios from "@/utils/axios"

interface ICartItem {
    pdt_id: string;
    variant_id: string;
    quantity: number;
}

export const syncUserCart = async (doc: { items: ICartItem[] }) => {
    try {
        let result = await axios.post(`${process.env.NEXT_PUBLIC_BOOKING_SERVICE}/cart/update`, doc)
        if (result.data?.status) {
            return { status: true, data: result.data?.data, message: result.data?.message }
        } else {
            return { status: false, message: result?.data?.message || result?.data?.error || "" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!" }
    }
}
export const userAddressList = async () => {
    try {
        let result = await axios.get(`${process.env.NEXT_PUBLIC_USER_SERVICE}/user/address-list`)
        if (result.data?.status) {
            return { status: true, data: result.data?.data, message: result.data?.message }
        } else {
            return { status: false, message: result?.data?.message || result?.data?.error || "" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!" }
    }
}
export const addAddress = async (doc: {[key:string]:any}) => {
    try {
        let result = await axios.post(`${process.env.NEXT_PUBLIC_USER_SERVICE}/user/address-add`, doc)
        if (result.data?.status) {
            return { status: true, data: result.data?.data, message: result.data?.message }
        } else {
            return { status: false,  message: result?.data?.message, error: result?.data?.error || "" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!" }
    }
}
export const updateAddress = async (doc: {[key:string]:any}) => {
    try {
        let result = await axios.post(`${process.env.NEXT_PUBLIC_USER_SERVICE}/user/address-update`, doc)
        if (result.data?.status) {
            return { status: true, data: result.data?.data, message: result.data?.message }
        } else {
            return { status: false, message: result?.data?.message, error: result?.data?.error || "" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!" }
    }
}
export const setUserAddress = async (doc: {[key:string]:any}) => {
    try {
        let result = await axios.post(`${process.env.NEXT_PUBLIC_USER_SERVICE}/user/address-set`, doc)
        if (result.data?.status) {
            return { status: true, data: result.data?.data, message: result.data?.message }
        } else {
            return { status: false,  message: result?.data?.message, error: result?.data?.error || "" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!" }
    }
}
export const addressDetails = async (doc: { address_id: string }) => {
    try {
        let result = await axios.post(`${process.env.NEXT_PUBLIC_USER_SERVICE}/user/address-details`, doc)
        if (result.data?.status) {
            return { status: true, data: result.data?.data, error: result.data?.error || "", message: result.data?.message }
        } else {
            return { status: false, message: result?.data?.message || result?.data?.error || "" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!", error: error?.message || "" }
    }
}
export const removeAddress = async (doc: { address_id: string }) => {
    try {
        let result = await axios.post(`${process.env.NEXT_PUBLIC_USER_SERVICE}/user/remove-address`, doc)
        if (result.data?.status) {
            return { status: true, data: result.data?.data, error: result.data?.error || "", message: result.data?.message }
        } else {
            return { status: false, message: result?.data?.message || result?.data?.error || "" }
        }
    } catch (error: any) {
        return { status: false, message: error?.message || "Something went wrong!", error: error?.message || "" }
    }
}
